import { createContext, useState, useMemo, useRef, useEffect } from "react";

// Create context
export const MapviewContext = createContext();

export const MapProvider = ({ children }) => {
    const [selectedPlace, setSelectedPlace] = useState("");
    const [storePlaceHistory, setStorePlaceHistory] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedTerritory, setSelectedTerritory] = useState("");
    const [selectedInnerTerritory, setSelectedInnerTerritory] = useState("");
    const [searchBarData, setSearchBarData] = useState([]);


    const contextValue = useMemo(() => ({
        selectedPlace,
        storePlaceHistory,
        selectedRegion,
        selectedTerritory,
        selectedInnerTerritory,
        searchBarData
    }), [selectedPlace, storePlaceHistory, selectedRegion, selectedTerritory, selectedInnerTerritory,searchBarData ]);

    const contextActions = useMemo(() => ({
        setSelectedPlace,
        setStorePlaceHistory,
        setSelectedRegion,
        setSelectedTerritory,
        setSelectedInnerTerritory,
        setSearchBarData
    }), []);

    return (
        <MapviewContext.Provider value={{ ...contextValue, ...contextActions }}>
            {children}
        </MapviewContext.Provider>
    );
};